<template>
  <div v-if="company">
    <GeneralData v-model="company" @input="formSaved" />
  </div>
</template>

<script>
import GeneralData from "../form/GeneralData";
import gql from "graphql-tag";

export default {
  components: {
    GeneralData
  },
  apollo: {
    company: {
      query: gql`
        query Company($id: ID!) {
          company(id: $id) {
            id
            l1UpdateRequested
            landwehrId
            name
            name2
            name3
            status
            state {
              id
              name
            }
            active
            postAddress {
              id
              number
              name
              name2
              name3
              street
              zip
              city
              country
              telephone
              telephone2
              fax
              email
              homepage
              salutation
              letterSalutation
            }
            deliveryAddress {
              id
              number
              name
              name2
              name3
              street
              zip
              city
              country
              telephone
              telephone2
              fax
              email
              homepage
              salutation
              letterSalutation
            }
            billingAddress {
              id
              number
              name
              name2
              name3
              street
              zip
              city
              country
              telephone
              telephone2
              fax
              email
              homepage
              salutation
              letterSalutation
            }
          }
        }
      `,
      variables() {
        return {
          id: this.$route.params.id
        };
      },
      error(error) {
        if (error.gqlError.message === "record not found") {
          this.fetchFailed = true;
        } else {
          this.fetchFailed = true;
          // TODO: Display different error message
        }
      }
    }
  },
  methods: {
    formSaved() {
      clearTimeout(this.saveInterval);
      this.saveInterval = setTimeout(async () => {
        await this.$apollo.mutate({
          mutation: gql`
            mutation($id: ID!, $input: CompanyInput!) {
              updateCompany(id: $id, input: $input) {
                id
              }
            }
          `,
          variables: {
            id: this.company.id,
            input: Object.prepareGqlInput(
              this.company,
              ["state"],
              ["l1UpdateRequested"]
            )
          }
        });

        this.$vs.notify({
          title: "Gespeichert",
          text: "Eingabe wurde erfolgreich gespeichert",
          color: "success",
          icon: "query_builder",
          position: "bottom-center"
        });
      }, 500);
    }
  }
};
</script>
